var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',_vm._g(_vm._b({attrs:{"value":_vm.value},on:{"change":(val) => _vm.$emit('input', val)}},'el-date-picker',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }